import Routes from "../Routes";
import Adapter from "../Adapter";

const App = () => {
  return (
    <Adapter>
      <Routes/>
    </Adapter>
  );
};

export default App;
